import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";

import Layout from "../../../components/layout/Layout";
import { Search } from "@mui/icons-material";

import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";

import { MdOutlineDelete } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit } from "react-icons/fi";
import Product from "../../../actions/product";
import AddProductForm from "../../../components/forms/updateProductListForm";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { createTheme, styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { useHistory, useLocation } from "react-router-dom";
import ProductDetails from "./productProfiel";
import {
  Grid,
  ListItemText,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const headCells = [
  { id: "sku", label: "Sku" },
  { id: "price", label: "Price" },
  { id: "quantity", label: "Quantity" },
  { id: "store", label: "Store" },
  { id: "createdAt", label: "CreatedAt" },
  { id: "updatedAt", label: "UpdatedAt" },

  { id: "actions", label: "Actions", disableSorting: true },
];
const Item = styled(Paper)(() => ({
  backgroundColor: "#f9f9f9", // light grey background for the card
  padding: "16px",
  textAlign: "left",
  color: "#333",
}));

const useStyles = makeStyles(() => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  listItem: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    marginBottom: "8px",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  primaryText: {
    fontWeight: "bold",
    color: "rgba(244,151,3,0.8)",
  },
  secondaryText: {
    color: "#666",
  },
}));
const ProductDetailPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { deleteProductList, getProduct } = Product();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [productData, setProductData] = useState(null);
  const [productLists, setProductLists] = useState([]);
  const [Id, setId] = useState();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  let location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getProductData(value);
    setId(value);
  }, [value]);
  const getProductData = (id) => {
    setValues({
      ...values,
      loading: true,
    });
    getProduct(id ? id : Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.product) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.product.productLists);
        setProductData(data.product);
      }
    });
  };
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteProductList(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setProductLists(
          produce(productLists, (draft) => {
            const index = productLists.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(productLists, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["price", "quantity"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const totalQuantity = productLists?.reduce(
    (total, list) => total + parseInt(list.quantity),
    0
  );

  return (
    <Layout>
      <div className="card">
        <Typography variant="h6" className="page-header">
          <ArrowBackIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/products");
            }}
          ></ArrowBackIcon>{" "}
          <span style={{ marginLeft: "6px" }}>Product Detail</span>
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Item>
                {productData && (
                  <ProductDetails
                    product={productData}
                    getProductData={getProductData}
                  />
                )}
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <span className={classes.primaryText}>Total Quantity</span>
                  <span className={classes.secondaryText}>{totalQuantity}</span>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <span className={classes.primaryText}>Price At Latest</span>
                  <span className={classes.secondaryText}>
                    {productLists &&
                      productLists.reduce(
                        (latest, item) =>
                          new Date(item.updatedAt) > new Date(latest.updatedAt)
                            ? item
                            : latest,
                        productLists[0] || {
                          price: "N/A",
                          updatedAt: "1970-01-01T00:00:00Z",
                        }
                      ).price}
                  </span>
                </Box>
              </Item>
            </Grid>
          </Grid>
        </Box>
        <div
          className="search-header-container"
          style={{ marginBottom: 0, flex: 1, maxWidth: 260, minWidth: 260 }}
        >
          <div className="search-header-flex">
            <div className="search-container">
              <Search className="search_icon" />
              <input
                type="text"
                onChange={handleSearch}
                placeholder="Search Product"
                className="search-input"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>

        <Grid container>
          <Grid item xs={12} className="card__body">
            {loading ? (
              <Loading />
            ) : (
              <>
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell style={{ width: "10%" }}>
                              {productData?.sku}
                            </TableCell>
                            <TableCell style={{ width: "10%" }}>
                              {item.price}
                            </TableCell>
                            <TableCell style={{ width: "15%" }}>
                              {item.quantity}
                            </TableCell>
                            <TableCell style={{ width: "15%" }}>
                              {item?.store?.locationName}
                            </TableCell>
                            <TableCell style={{ width: "15%" }}>
                              {new Date(item.createdAt).toLocaleDateString()}
                            </TableCell>
                            <TableCell style={{ width: "15%" }}>
                              {new Date(item.updatedAt).toLocaleDateString()}
                            </TableCell>
                            <TableCell style={{ width: "10%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                }}
                              >
                                <Controls.ActionButton
                                  color="secondary"
                                  title="Delete"
                                  onClick={() => {
                                    setConfirmDialog({
                                      isOpen: true,
                                      title:
                                        "Are you sure to delete this Product List?",
                                      subTitle: "You can't undo this operation",
                                      onConfirm: () => {
                                        onDelete(item.id);
                                      },
                                    });
                                  }}
                                >
                                  <MdOutlineDelete fontSize="medium" />
                                </Controls.ActionButton>
                                <Controls.ActionButton
                                  color="primary"
                                  title="Update"
                                  onClick={() => {
                                    setOpenPopup(true);
                                    setRecordForEdit(item);
                                    setEdit(true);
                                  }}
                                >
                                  <FiEdit fontSize="medium" />
                                </Controls.ActionButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                </Paper>
                <TblPagination />
              </>
            )}
          </Grid>
        </Grid>

        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
        <Notification notify={notify} setNotify={setNotify} />
      </div>
      <Popup
        title="Product List Update Form"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <AddProductForm
          NotifyMessage={NotifyMessage}
          setOpenPopup={setOpenPopup}
          recordForEdit={recordForEdit}
          setProducts={setProductLists}
          getProductData={getProductData}
          id={value}
          edite={edite}
        />
      </Popup>
    </Layout>
  );
};

export default ProductDetailPage;
